import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { FaFileExcel } from 'react-icons/fa';
import { FormattedMessage, injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import messages from './relationOverviewMessages';

const ExportButton = props => {
  const {
    intl,
    disabled,
    exporting,
    onCreateExcelReport,
    onCreateAuthorizationReport,
    onCreateLinkedRelationsReport,
    onCreateFiscalReport,
    onCreateCommunicationChannelReport,
    onCreateCommunicationSettingReport,
  } = props;

  return (
    <DropdownButton
      bsSize="xsmall"
      bsStyle="default"
      className="btn-default margin10R"
      id="export-button"
      disabled={exporting || disabled}
      pullRight
      title={
        <span>
          <span className="margin5R">
            {exporting && <i className="fa fa-spinner fa-spin" />}
            {!exporting && <FaFileExcel className="file-icon" />}
          </span>
          <FormattedMessage {...messages.Export} />
        </span>
      }
    >
      <MenuItem onClick={onCreateExcelReport} id="export-button-CreateExcelReport">
        {intl.formatMessage(messages.ExportRelations)}
      </MenuItem>
      <MenuItem onClick={onCreateAuthorizationReport} id="export-button-CreateAuthorizationReport">
        {intl.formatMessage(messages.ExportAuthorizations)}
      </MenuItem>
      <MenuItem
        onClick={onCreateLinkedRelationsReport}
        id="export-button-CreateLinkedRelationsReport"
      >
        {intl.formatMessage(messages.ExportLinkedRelations)}
      </MenuItem>
      <MenuItem onClick={onCreateFiscalReport} id="export-button-CreateFiscalReport">
        {intl.formatMessage(messages.ExportFiscalSections)}
      </MenuItem>
      <MenuItem
        onClick={onCreateCommunicationChannelReport}
        id="export-button-CreateCommunicationChannelReport"
      >
        {intl.formatMessage(messages.ExportCommunicationChannels)}
      </MenuItem>
      <MenuItem
        onClick={onCreateCommunicationSettingReport}
        id="export-button-CreateCommunicationSettingReport"
      >
        {intl.formatMessage(messages.ExportCommunicationSettings)}
      </MenuItem>
    </DropdownButton>
  );
};

ExportButton.propTypes = {
  intl: intlShape.isRequired,
  onCreateExcelReport: PropTypes.func.isRequired,
  onCreateAuthorizationReport: PropTypes.func.isRequired,
  onCreateLinkedRelationsReport: PropTypes.func.isRequired,
  onCreateFiscalReport: PropTypes.func.isRequired,
  onCreateCommunicationChannelReport: PropTypes.func.isRequired,
  onCreateCommunicationSettingReport: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  exporting: PropTypes.bool,
};
ExportButton.defaultProps = { disabled: false, exporting: false };
export default injectIntl(ExportButton);
